package com.milta.feature.team.data.remote.dto

import com.milta.feature.team.domain.entity.Enterprise
import kotlinx.serialization.Serializable

@Serializable
data class EnterpriseDto(
    val id: String,
    val name: String,
)

fun EnterpriseDto.toDomain() = Enterprise(id = id, name = name)
